import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import arrow from './arrow_gray.svg';
import {SlideDown} from 'react-slidedown'
import './slidedown.css'

const SelectWrap = styled.div`
  font-size: 16px;
  line-height: 19px;
  z-index: 10;
  position: relative;
  min-width: 190px;
`;

const SelectHead = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 14px 52px 11px 18px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 20px;
  z-index: 2;
  background-color: #F1F1F1;
  box-shadow: 0 27px 70px rgba(255, 255, 255, 0.49), 0 11.2813px 39.2646px rgba(255, 255, 255, 0.465918), 0 5.5641px 23.4931px rgba(255, 255, 255, 0.371459), 0 2.6831px 16.3802px rgba(255, 255, 255, 0.252213), 0 1.12926px 11.2835px rgba(255, 255, 255, 0.130101), 0 0.32782px 6.00087px rgba(255, 255, 255, 0.0277009);

  &:before {
    content: url(${arrow});
    position: absolute;
    top: calc(50% - 5px);
    right: 14px;
    display: block;
    width: 19px;
    height: 11px;
    transition: all 0.15s;
    transform: rotate(${props => props.show ? '180deg' : '0deg'});
  }
`;

const SelectListWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 16px;
`;

const SelectList = styled.div`
  padding: 47px 10px 20px 18px;
  background-color: #F1F1F1;
  border-radius: 20px;
`;

const SelectOption = styled.div`
  position: relative;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: max-content;
  transition: all 0.1s;
  color: ${props => props.active ? '#F0B538' : 'inherit'};
  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    color: #FFCD00;
  }
`;

const Select = ({options, selected, onChange}) => {
  const [isOpen, setIsOpen] = useState(false);

  const close = () => setIsOpen(false);

  const change = option => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  return (
    <SelectWrap onClick={e => e.stopPropagation()}>
      <SelectHead show={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {typeof selected.title === 'function' ? selected.title() : selected.title}
      </SelectHead>
      <SelectListWrap>
        <SlideDown>
          {isOpen && <SelectList>
            {options.map(option => (
              <SelectOption val={option.val} active={option.val === selected.val} key={option.val}
                            onClick={() => change(option)}
              >
                {typeof option.title === 'function' ? option.title() : option.title}
              </SelectOption>))
            }
          </SelectList>}
        </SlideDown>
      </SelectListWrap>
    </SelectWrap>
  )
}

export default Select
